import React from 'react';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import CssBaseline from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import makeStyles from '@mui/styles/makeStyles';
import Container from '@mui/material/Container';
import AWSBackgroundImage from '../../assets/images/amazon-cloud-bg.jpg';

const useStyles = makeStyles((theme:any) => ({
  icon: {
    marginRight: theme.spacing(2),
  },
  heroContent: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(8, 0, 6),
  },
  heroButtons: {
    marginTop: theme.spacing(4),
  },
  cardGrid: {
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
  },
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  cardMedia: {
    paddingTop: '56.25%', // 16:9
  },
  cardContent: {
    flexGrow: 1,
  },
  footer: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(6),
  },
}));

export default function Support() {
  const classes = useStyles();

  return (
    <React.Fragment>
      <CssBaseline />
     
      <main>
        {/* Hero unit */}
        <div className={classes.heroContent}>
          <Container maxWidth="sm">
            <Typography component="h1" variant="h2" align="center" color="textPrimary" gutterBottom>
              Support
            </Typography>
            <Typography variant="h5" align="center" color="textSecondary" paragraph>
            All signature requests or other legal term issues must be immediately escalated to the AWS Legal team.
            </Typography>
            <div className={classes.heroButtons}>
              <Grid container spacing={2} justifyContent="center">
                <Grid item>
                  <Button variant="contained" color="primary" href="https://t.corp.amazon.com/create/options?title=AWS+RFI%2C+RFP+or+Security+Questionnaire+%28EMEA-Commercial%29%3A+%5BInsert+Customer+Name%5D&description=This+ticket+is+used+to+request+legal+support+for+an+RFI%2C+RFP%2C+or+Security+Questionnaire%3A+please+modify+the+title+of+the+ticket+depending+on+your+request.++%0A%0ABEFORE+RAISING+THIS+TICKET%2C+TAKE+STEPS+1%2C+2%2C+AND+3+IMMEDIATELY+BELOW%3A+%0A%0ASTEP+1.+REVIEW+AND+FOLLOW+the+applicable+process+requirements+on+SHERPA%3A%0A%0ARFIs+%26+RFPs+Process%3A+https%3A%2F%2Flegal.amazon.com%2Fsites%2FAWS-Collab%2Fagreementresources%2FSherpa%2FSitePages%2FRFIsRFPsVendorForms%2FRFxAndSecurityQuestionnaireProcessRequirements.aspx++%0A%0ASECURITY+QUESTIONNAIRE+Process%3A+https%3A%2F%2Flegal.amazon.com%2Fsites%2FAWS-Collab%2Fagreementresources%2FSherpa%2FSitePages%2FRFIsRFPsVendorForms%2FSecurityQuestionnaireProcess.aspx++%0A%0ASTEP+2.+COMPLETE+the+RFI%2C+RFP+or+Security+Questionnaire+with+the+resources+provided+on+SHERPA+in+the+Response+Reference+Library+and+RFIs+RFPs+FAQs.+If+these+SHERPA+pages+do+not+have+the+information+requested%2C+obtain+additional+assistance+from+the+relevant+teams+%28e.g.+Compliance%2C+Security+Assurance%2C+Accounts+Receivable%2C+Finance%2C+Business+Practices+or+other+internal+teams%29.%0A%0ASTEP+3.The+Customer+Optimization+%26+Enablement+team+may+be+able+to+assist+with+certain+matters+described+here%3A+https%3A%2F%2Fwisdom.corp.amazon.com%2FPages%2FEMEA-CE-Team.aspx.%0A%0ASTEP+4.+If+there+are+legal+terms+in+the+RFI%2C+RFP+or+Security+Questionnaire+and+you+are+unable+to+fully+complete+the+document+using+the+information+and+resources+described+above%2C+please+follow+the+steps+A+%26+B+below+to+request+support+from+the+legal+team%3A%0A%0ASTEP+A+-+Answer+the+following+questions%3A%0A%0A1.+Is+this+customer+a+Global+Account%2C+Global+Financial+Services+Account%2C+Global+Telecom+Account%2C+or+Strategic+Account+%3F++If+yes%2C+which%3F%0A%0A2.+Is+the+Customer+a+Public+or+quasi-Public+entity+%28directly+or+indirectly%2C+entirely+or+partially%2C+owned+by+the+State%29%2C+an+entity+operating+in+utilities+sectors+%28gas%2C+electricity%2C+water%2C+energy%2C+transport%2C+postal+sectors%29+or+an+entity+required+to+apply+public+procurement+laws%3F+%5Byes%2Fno%5D+%5Bif+yes+please+specify+which+one%5D+%0A%0AIf+yes%2C+is+there+any+request+in+the+questionnaire+regarding+the+compliance+of+AWS+with+public+procurement+laws%3F+%5Byes%2Fno%5D%0A%0A3.+What+is+the+full+name+of+the+Customer%3F%0A%0A4.+Under+which+agreement+is+the+Customer%3F+%5BOnline+Customer+Agreement%5D+or+%5BEnterprise+Agreement%5D%0A%0A5.+When+is+the+questionnaire+due+to+the+Customer%3F%0A%0A6.+Has+the+COE+team+been+involved+for+this+request+%28https%3A%2F%2Fwisdom.corp.amazon.com%2FPages%2FEMEA-CE-Team.aspx%29%3F%0A%0A7.+Which+parts+of+the+questionnaire+require+legal+assistance%3F%0A%0A8.+Did+you+receive+a+request+to+complete+a+%E2%80%9CEuropean+Single+Procurement+Document%E2%80%9D+%28ESPD%29%3F+%0A%0A9.+Detail+any+specific+concerns+linked+to+this+request%3A+%0A%0ASTEP+B+-+Attach+to+this+ticket+%28under+the+Related+Items+tab%29+the+applicable+RFI%2C+RFP+or+Security+Questionnaire+ALREADY+COMPLETED+and+any+relevant+documents.++%0A%0AALLOW+UP+TO+THREE+%283%29+BUSINESS+DAYS+FOR+INITIAL+LEGAL+REVIEW&ticket_type=Secure+Ticket&severity=FIVE&category=AWS&type=Legal&item=AWS+RFI%2FRFP+%28EMEA%29&building_id=NOT-FOUND&group=AWS+RFI%2FRFP+%28EMEA%29&assignee=sanotraa&add_perm=%27sanotraa%27%3B%27maparent%27%3B%27chagunn%27%3B%27quickk%27%3B%27babmaria%27%3B%27markoval%27%3B%27carmchan%27&asin=&quantity=&isd=&upc=&binding=&vendor_id=&purchase_order_id=&stock_number=&ship_origin=&invoice_number=&physical_location=&tracking_number=&bol_number=&picture_file_imdex_location=&vendor_info_title=" target="_blank">
                    Request EMEA Legal Support
                  </Button>
                </Grid>
              </Grid>
            </div>
          </Container>
        </div>

        <Container className={classes.cardGrid} maxWidth="md">
                <Card className={classes.card}>
                  <CardMedia
                    className={classes.cardMedia}
                    image={AWSBackgroundImage}
                    title="Amazon Logo"
                  />
                </Card>  
        </Container>
      </main>
    </React.Fragment>
  );
}